"use strict";

// Auto-focus and auto-submit for 2FA inputs
document.addEventListener('DOMContentLoaded', function() {
    const wizardForm = document.querySelector('form#loginForm');
    if (!wizardForm) return;
    
    const currentStepInput = wizardForm.querySelector('input[name*="current_step"]');
    if (!currentStepInput) return;
    
    const currentStep = currentStepInput.value;
    
    if (currentStep !== 'token' && currentStep !== 'backup') {
        return;
    }
    
    // Find the code input field
    let codeInput = wizardForm.querySelector('input[name*="otp_token"]');
    if (!codeInput) {
        codeInput = wizardForm.querySelector('#id_token-otp_token');
    }
    if (!codeInput) {
        codeInput = wizardForm.querySelector('input[name="token-otp_token"]');
    }
    
    if (!codeInput) return;
    
    const isToken = currentStep === 'token';
    const isBackup = currentStep === 'backup';
    
    let tokenInput = isToken ? codeInput : null;
    let backupInput = isBackup ? codeInput : null;
    
    // Handle regular token input
    if (tokenInput) {
        tokenInput.classList.add('two-factor-token-input', 'form-control-lg', 'text-center');
        tokenInput.setAttribute('autocomplete', 'one-time-code');
        tokenInput.setAttribute('inputmode', 'numeric');
        tokenInput.setAttribute('maxlength', '6');
        // Only set placeholder if it doesn't already have one
        if (!tokenInput.getAttribute('placeholder')) {
            tokenInput.setAttribute('placeholder', '• • • • • •');
        }
        tokenInput.focus();
        
        // Auto-submit when 6 digits are entered
        tokenInput.addEventListener('input', function(e) {
            const value = e.target.value.replace(/[^0-9]/g, '');
            
            if (e.target.value !== value) {
                e.target.value = value;
                e.target.dispatchEvent(new Event('change', { bubbles: true }));
            }
            
            if (value.length === 6) {
                // Add delay to ensure token is valid when submitted
                e.target.disabled = false;
                submitForm();
            }
        });
        
        // Auto-submit on paste
        tokenInput.addEventListener('paste', function(e) {
            const value = this.value.replace(/[^0-9]/g, '');
            this.value = value;
            
            if (value.length === 6) {
                submitForm();
            }
        });
    }
    
    // Handle backup code input
    if (backupInput) {
        backupInput.type = 'text';
        backupInput.classList.add('form-control-lg', 'text-center');
        backupInput.removeAttribute('inputmode');
        backupInput.removeAttribute('pattern');
        backupInput.removeAttribute('min');
        backupInput.removeAttribute('max');
        backupInput.removeAttribute('step');
        backupInput.setAttribute('autocomplete', 'off');
        backupInput.setAttribute('placeholder', 'xxxxxxxx');
        backupInput.focus();
        
        backupInput.addEventListener('input', function(e) {
            const value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
            e.target.value = value.toLowerCase();
        });
        
        backupInput.addEventListener('paste', function(e) {
            const value = this.value.trim();
            if (value.length >= 6) {
                submitForm();
            }
        });
    }
    
    // Prevent double submission (causes CSRF error)
    let isSubmitting = false;
    wizardForm.addEventListener('submit', function(e) {
        if (isSubmitting) {
            e.preventDefault();
            return;
        }
        isSubmitting = true;
        const submitButton = wizardForm.querySelector('button#kt_sign_in_submit[type="submit"]');
        if (submitButton) {
            submitButton.disabled = true;
        }
    });

    function submitForm() {
        // Get the main form
        const form = document.querySelector('form#loginForm');
        if (!form) return;

        // Check if we have a token input and it has a value
        const tokenInput = form.querySelector('input[name*="otp_token"]');
        if (tokenInput && !tokenInput.value) return;

        // Find the actual submit button (not the hidden one)
        const submitButton = form.querySelector('button#kt_sign_in_submit[type="submit"]');
        if (!submitButton || submitButton.disabled) return;

        // Use requestSubmit if available (modern browsers)
        if (form.requestSubmit) {
            form.requestSubmit(submitButton);
        } else {
            // Fallback for older browsers
            submitButton.click();
        }
    }
});